<template>
    <div>
        <!-- Header Start -->
        <div class="row">
            <div class="col-md-5">
                <h2>Service Overview <i class="fas fa-info-circle fa-xs ml-3 mt-2" id="serviceOverview"></i></h2>
                <b-popover
                    target="serviceOverview"
                    title="Service Overview"
                    triggers="hover focus"
                    placement="right"
                    :content="tooltip.serviceOverview"
                ></b-popover>
            </div>
            <div class="col-md-7">
                <period
                    @newDateRange="newDateRange"
                ></period>
            </div>
        </div>
        <!-- Header End -->

        <!-- Stats Start -->
        <div class="row mt-4">
            <!-- {{data.overview}} -->
            <div class="col-md" v-for="stats in statsOptions[currPeriod]" :key="stats.title">
                <small-stats
                    :title="stats.title"
                    :value="data.overview ? loadEval(stats.value) : 'Loading....'"
                    :background_color="stats.background_color"
                ></small-stats>
            </div>
            
        </div>
        <!-- Stats End -->

        <!-- Unit Entry Analysis Start -->
        <div class="outerBox mt-5">
            <div class="row innerBox">
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h2>Unit Entry Analysis <i class="fas fa-info-circle fa-xs ml-3 mt-2" id="unitEntryAnalysis"></i></h2>
                            <b-popover
                                target="unitEntryAnalysis"
                                title="Unit Entry Analysis"
                                triggers="hover focus"
                                placement="top"
                                :content="tooltip.unitEntryAnalysis"
                            ></b-popover>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-3 offset-md-3">
                                    <div class="input-group">
                                        <button
                                            class="btn btn-primary astraColorButton"
                                            @click="exportFile('Unit Entry Analysis', 'csv', data.analysis)"
                                        >
                                            Download CSV <i class="fas fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter.analysis.region"
                                        class="dealerService"
                                        :options="options.analysis.region"
                                        placeholder="All Wilayah Kerja"
                                      ></MultiSelect>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter.analysis.dealer"
                                        class="dealerService"
                                        :options="options.analysis.dealer.map(x => x.dealer)"
                                        placeholder="All Dealer"
                                      ></MultiSelect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <unit-entry-analysis
                        v-if="data.analysis"
                        :data="data.analysis"
                    ></unit-entry-analysis>
                </div>
            </div>
        </div>
        <!-- Unit Entry Analysis End -->

        <!-- Unit Entry By Region Start -->
        <div class="outerBox mt-5">
            <div class="row innerBox">
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h2>Unit Entry By Wilayah Kerja <i class="fas fa-info-circle fa-xs ml-3 mt-2" id="unitEntryByRegion"></i></h2>
                            <b-popover
                                target="unitEntryByRegion"
                                title="Unit Entry By Wilayah Kerja"
                                triggers="hover focus"
                                placement="top"
                                :content="tooltip.unitEntryByRegion"
                            ></b-popover>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                           <div class="btn-group">
                               <button
                                type="button"
                                class="btn"
                                :class="filter.region.flag == 'REGION' ? 'astraColorButton' : 'astraColorButtonOutline'"
                                style="width: 150px; height:80%"
                                @click="filter.region.flag = 'REGION'"
                            >Wilayah Kerja</button>
                            <button
                                type="button"
                                class="btn"
                                :class="filter.region.flag == 'DEALER' ? 'astraColorButton' : 'astraColorButtonOutline'"
                                style="width: 150px; height:80%"
                                @click="filter.region.flag = 'DEALER'"
                            >Dealer</button>
                           </div> 
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <!-- Special Multiselect Start -->
                                <div :class="opened.dealer ? 'col-md-9' : 'col-md-6 offset-md-3'" v-if="filter.region.flag == 'DEALER'">
                                    <div class="input-group">
                                        <MultiSelect
                                            v-model="specialFilter.region.dealer"
                                            class="dealerService"
                                            :options="options.region.dealer"
                                            :multiple="true"
                                            :close-on-select="false"
                                            :clear-on-select="false"
                                            placeholder="Select Dealer"
                                            @open="opened.dealer = true"
                                            @close="opened.dealer = false"
                                        >
                                            <template
                                                slot="selection"
                                                slot-scope="{ values, search, isOpen }"
                                            >
                                                <span
                                                    class="multiselect__single"
                                                    v-if="values.length && !isOpen"
                                                >
                                                    {{ determineText(values, 16) }}
                                                </span>
                                            </template>
                                        </MultiSelect>
                                    </div>
                                </div>
                                <!-- Special Multiselect End -->
                                <div class="col-md-3" :class="filter.region.flag == 'REGION' ? 'offset-md-9' : ''">
                                    <div class="input-group">
                                        <button
                                            class="btn btn-primary astraColorButton"
                                            @click="exportFile('Unit Entry By ' + filter.region.flag, 'csv', data.region)"
                                        > Download CSV <i class="fas fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <unit-entry-by-region
                        v-if="regionData"
                        :data="regionData"
                    ></unit-entry-by-region>
                </div>
            </div>
        </div>
        <!-- Unit Entry By Region End -->

        <!-- Unit Entry By Model Start -->
        <div class="outerBox mt-5">
            <div class="row innerBox">
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h2>Unit Entry By Model <i class="fas fa-info-circle fa-xs ml-3 mt-2" id="unitEntryByModel"></i></h2>
                            <b-popover
                                target="unitEntryByModel"
                                title="Unit Entry By Model"
                                triggers="hover focus"
                                placement="top"
                                :content="tooltip.unitEntryByModel"
                            ></b-popover>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-3 offset-md-3">
                                    <div class="input-group">
                                        <button
                                            class="btn btn-primary astraColorButton"
                                            @click="exportFile('Unit Entry By Model', 'csv', data.model)"
                                        >
                                            Download CSV <i class="fas fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter.model.region"
                                        class="dealerService"
                                        :options="options.model.region"
                                        placeholder="All Wilayah Kerja"
                                      ></MultiSelect>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter.model.dealer"
                                        class="dealerService"
                                        :options="options.model.dealer.map(x => x.dealer)"
                                        placeholder="All Dealer"
                                      ></MultiSelect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <unit-entry-by-model
                        v-if="data.model"
                        :data="data.model"
                    ></unit-entry-by-model>
                </div>
            </div>
        </div>
        <!-- Unit Entry By Model End -->

        <!-- Unit Entry By Production Year Start -->
        <div class="outerBox mt-5">
            <div class="row innerBox">
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h2>Unit Entry By Production Year <i class="fas fa-info-circle fa-xs ml-3 mt-2" id="unitEntryByProductionYear"></i></h2>
                            <b-popover
                                target="unitEntryByProductionYear"
                                title="Unit Entry By Production Year"
                                triggers="hover focus"
                                placement="top"
                                :content="tooltip.unitEntryByProductionYear"
                            ></b-popover>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="input-group">
                                        <button
                                            class="btn btn-primary astraColorButton"
                                            @click="exportFile('Unit Entry By Production Year', 'csv', data.productionYear)"
                                        >
                                            Download CSV <i class="fas fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter.productionYear.model"
                                        class="dealerService"
                                        :options="options.productionYear.type"
                                        placeholder="All Type"
                                      ></MultiSelect>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter.productionYear.region"
                                        class="dealerService"
                                        :options="options.productionYear.region"
                                        placeholder="All Wilayah Kerja"
                                      ></MultiSelect>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter.productionYear.dealer"
                                        class="dealerService"
                                        :options="options.productionYear.dealer.map(x => x.dealer)"
                                        placeholder="All Dealer"
                                      ></MultiSelect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <unit-entry-by-production-year
                        v-if="data.productionYear"
                        :data="data.productionYear"
                    ></unit-entry-by-production-year>
                </div>
            </div>
        </div>
        <!-- Unit Entry By Production Year End -->

        <!-- Unit Entry By Color Start -->
        <div class="outerBox mt-5">
            <div class="row innerBox">
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h2>Unit Entry By Color <i class="fas fa-info-circle fa-xs ml-3 mt-2" id="unitEntryByColor"></i></h2>
                            <b-popover
                                target="unitEntryByColor"
                                title="Unit Entry By Color"
                                triggers="hover focus"
                                placement="top"
                                :content="tooltip.unitEntryByColor"
                            ></b-popover>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="input-group">
                                        <button
                                            class="btn btn-primary astraColorButton"
                                            @click="exportFile('Unit Entry By Color', 'csv', data.color)"
                                        >
                                            Download CSV <i class="fas fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter.color.model"
                                        class="dealerService"
                                        :options="options.color.type"
                                        placeholder="All Type"
                                      ></MultiSelect>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter.color.region"
                                        class="dealerService"
                                        :options="options.color.region"
                                        placeholder="All Wilayah Kerja"
                                      ></MultiSelect>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="input-group">
                                      <MultiSelect
                                        v-model="filter.color.dealer"
                                        class="dealerService"
                                        :options="options.color.dealer.map(x => x.dealer)"
                                        placeholder="All Dealer"
                                      ></MultiSelect>
                                    </div>
                                </div>
                                <!-- Special Multiselect Start -->
                                <div class="mt-3" :class="opened.color ? 'col-md-12' : 'col-md-6 offset-md-6'">
                                    <div class="input-group">
                                        <MultiSelect
                                            v-model="specialFilter.color.color"
                                            class="dealerService"
                                            :options="options.color.color"
                                            :multiple="true"
                                            :close-on-select="false"
                                            :clear-on-select="false"
                                            placeholder="Select Color"
                                            @open="opened.color = true"
                                            @close="opened.color = false"
                                        >
                                            <template
                                                slot="selection"
                                                slot-scope="{ values, search, isOpen }"
                                            >
                                                <span
                                                    class="multiselect__single"
                                                    v-if="values.length && !isOpen"
                                                >
                                                    {{ determineText(values, 24) }}
                                                </span>
                                            </template>
                                        </MultiSelect>
                                    </div>
                                </div>
                                <!-- Special Multiselect End -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <unit-entry-by-color
                        v-if="colorData"
                        :data="colorData"
                    ></unit-entry-by-color>
                </div>
            </div>
        </div>
        <!-- Unit Entry By Color End -->

    </div>
</template>

<script>
    import moment from 'moment'
    import XLSX from 'xlsx'
    import tooltip from '@/Options/tooltips.js'

    import period from './../children/period'

    import smallStats from './children/smallStats'

    import unitEntryAnalysis from './charts/unitEntryAnalysis'
    import unitEntryByRegion from './charts/unitEntryByRegion'
    import unitEntryByModel from './charts/unitEntryByModel'
    import unitEntryByProductionYear from './charts/unitEntryByProductionYear'
    import unitEntryByColor from './charts/unitEntryByColor'

    export default {
        data () {
            return {
                tooltip : tooltip.dealerService,
                moment : moment,
                currPeriod : 1,
                statsOptions : {
                    1 : [{
                        title : 'Yesterday - ' + moment().add('-1' , 'day').format('D MMMM'),
                        value : "this.numberWithCommas(this.data.overview.yesterday)",
                        background_color : '#80D6FF'
                    }, {
                        title : 'This Week - Week ' + (moment().weeks() - moment().add(0, 'month').startOf('month').weeks() + 1).toString(),
                        value : "this.numberWithCommas(this.data.overview.this_week)",
                        background_color : '#FBA2A8'
                    }, {
                        title : 'This Month - ' + moment().format('MMMM'),
                        value : "this.numberWithCommas(this.data.overview.total)",
                        background_color : '#6FD9D1'
                    }],
                    2 : [{
                        title : 'Week 1',
                        value : "this.numberWithCommas(this.data.overview.week_1)",
                        background_color : '#80D6FF'
                    },{
                        title : 'Week 2',
                        value : "this.numberWithCommas(this.data.overview.week_2)",
                        background_color : '#FBA2A8'
                    },{
                        title : 'Week 3',
                        value : "this.numberWithCommas(this.data.overview.week_3)",
                        background_color : '#6FD9D1'
                    },{
                        title : 'Week 4',
                        value : "this.numberWithCommas(this.data.overview.week_4)",
                        background_color : '#d4a2fb'
                    },{
                        title : 'Last Month - ' + moment().add('-1' , 'month').format('MMMM'),
                        value : "this.numberWithCommas(this.data.overview.total)",
                        background_color : '#ebc87f'
                    }],
                    3 : [{
                        title : 'Quarter 1 - ' + moment().year(),
                        value : "this.numberWithCommas(this.data.overview.q1)",
                        background_color : '#80D6FF'
                    },{
                        title : 'Quarter 2 - ' + moment().year(),
                        value : "this.numberWithCommas(this.data.overview.q2)",
                        background_color : '#FBA2A8'
                    },{
                        title : 'Quarter 3 - ' + moment().year(),
                        value : "this.numberWithCommas(this.data.overview.q3)",
                        background_color : '#6FD9D1'
                    },{
                        title : 'Quarter 4 - ' + moment().year(),
                        value : "this.numberWithCommas(this.data.overview.q4)",
                        background_color : '#d4a2fb'
                    },{
                        title : 'This Year - ' + moment().year(),
                        value : "this.numberWithCommas(this.data.overview.total)",
                        background_color : '#ebc87f'
                    }],
                    4 : [{
                        title : 'Quarter 1 - ' + moment().add('-1' , 'year').year(),
                        value : "this.numberWithCommas(this.data.overview.q1)",
                        background_color : '#80D6FF'
                    },{
                        title : 'Quarter 2 - ' + moment().add('-1' , 'year').year(),
                        value : "this.numberWithCommas(this.data.overview.q2)",
                        background_color : '#FBA2A8'
                    },{
                        title : 'Quarter 3 - ' + moment().add('-1' , 'year').year(),
                        value : "this.numberWithCommas(this.data.overview.q3)",
                        background_color : '#6FD9D1'
                    },{
                        title : 'Quarter 4 - ' + moment().add('-1' , 'year').year(),
                        value : "this.numberWithCommas(this.data.overview.q4)",
                        background_color : '#d4a2fb'
                    },{
                        title : 'Last Year - ' + moment().add('-1' , 'year').year(),
                        value : "this.numberWithCommas(this.data.overview.total)",
                        background_color : '#ebc87f'
                    }],
                    5 : [{
                        title : 'Total Custom Range',
                        value : "this.numberWithCommas(this.data.overview.total)",
                        background_color : '#80D6FF'
                    }]
                },
                options : {
                    analysis : {
                        region : this.$store.getters.getRegion,
                        dealer : this.$store.getters.getDealer
                    },
                    region : {
                        dealer : [],
                    },
                    model : {
                        region : this.$store.getters.getRegion,
                        dealer : this.$store.getters.getDealer
                    },
                    productionYear : {
                        region : this.$store.getters.getRegion,
                        dealer : this.$store.getters.getDealer,
                        type : this.$store.getters.getType,
                    },
                    color : {
                        region : this.$store.getters.getRegion,
                        dealer : this.$store.getters.getDealer,
                        type : this.$store.getters.getType,
                        color : [],
                    }
                },
                specialFilter : {
                    region : {
                        dealer : [],
                    },
                    color : {
                        color : [],
                    },
                },
                opened : {
                    dealer : false,
                    color : false,
                }
            }
        },
        props:['filter', 'periodFilter', 'data'],
        components : {
            period,

            smallStats,

            unitEntryAnalysis,
            unitEntryByRegion,
            unitEntryByModel,
            unitEntryByProductionYear,
            unitEntryByColor,
        },
        mounted () {
            this.determineSelectedDealer();
            this.determineSelectedColor();
        },
        watch : {
            'filter.analysis.region' () {
                this.filter.analysis.dealer = null;
                this.options.analysis.dealer = this.$store.getters.getDealerByRegion(this.filter.analysis.region);
            },
            'filter.model.region' () {
                this.filter.model.dealer = null;
                this.options.model.dealer = this.$store.getters.getDealerByRegion(this.filter.model.region);
            },
            'filter.productionYear.region' () {
                this.filter.productionYear.dealer = null;
                this.options.productionYear.dealer = this.$store.getters.getDealerByRegion(this.filter.productionYear.region);
            },
            'filter.color.region' () {
                this.filter.color.dealer = null;
                this.options.color.dealer = this.$store.getters.getDealerByRegion(this.filter.color.region);
            },
            'data.color' () {
                this.determineSelectedColor();
            },
            'data.region' () {
                this.determineSelectedDealer();
            },
        },
        computed : {
            colorData () {
                if (!this.data.color) return null;

                let data = []
                for (var i in this.data.color) {
                    //Find if color is selected
                    if (this.specialFilter.color.color.indexOf(this.data.color[i].color_code) != -1) data.push(this.data.color[i])
                }
                return data;
            },
            regionData () {
                if (this.filter.region.flag == 'REGION') return this.data.region;
                if (!this.data.region) return null;

                let data = []
                for (var i in this.data.region) {
                    //Find if dealer is selected
                    if (this.specialFilter.region.dealer.indexOf(this.data.region[i].region) != -1) data.push(this.data.region[i])
                }
                return data;
            },
        },
        methods : {
            loadEval(x) {
                return eval(x)
            },
            newDateRange(obj){
                this.currPeriod = obj.period ? obj.period : 1
                this.$emit('newDateRange', 'serviceOverview', obj);
            },
            exportFile(fileName, type, data){
                let wb = XLSX.utils.book_new()
                var ws = XLSX.utils.json_to_sheet(data, {raw:true});
                XLSX.utils.book_append_sheet(wb, ws, 'Data')

                let exportFileName = `${fileName}.${type}`
                XLSX.writeFile(wb, exportFileName)
            },
            determineText (obj, maxLength) {
                let text = ''
                for (var i = 0; i < obj.length; i++) {
                    text += `${obj[i]}, `
                }
                return (text.slice(0, text.length-2).length > maxLength) ? `${text.slice(0, maxLength)}...` : text.slice(0, text.length-2)
            },
            determineSelectedColor () {
                if (!this.data.color) return [];

                let data = JSON.parse(JSON.stringify(this.data.color))

                //Sort data
                data.sort((a,b) => (a.count > b.count) ? 1 : ((b.count > a.count) ? -1 : 0)).reverse();

                //Set options
                this.options.color.color = data.map(x=>x.color_code);

                //Cut 10 short (bcs of top 10)
                if (data.length > 10) data = data.splice(0, 10);

                this.specialFilter.color.color = data.map(x=>x.color_code);
            },
            determineSelectedDealer () {
                if (this.filter.region.flag == 'REGION') return;
                if (!this.data.region) return [];

                let data = JSON.parse(JSON.stringify(this.data.region))

                //Set options
                this.options.region.dealer = data.map(x=>x.region);

                //Sort data
                data.sort((a,b) => (a.count > b.count) ? 1 : ((b.count > a.count) ? -1 : 0)).reverse();

                //Cut 10 short (bcs of top 10)
                if (data.length > 10) data = data.splice(0, 10);

                this.specialFilter.region.dealer = data.map(x=>x.region);
            },
        }
    }
</script>

<style scoped>
    
</style>